import { css, styled } from 'styled-components';
import { shouldIgnoreProp } from '../../../utils/shouldIgnoreProp';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { DESKTOP_TEXT_WIDTH } from './constants';

interface RootParams {
    isMobile: boolean;
}

export const Root = styled(Flex)
    .withConfig({ displayName: 'PostDetailsCard' })
    .attrs<RootParams>((props) => ({
        ...props,
        position: 'relative',
        width: '100%',
        direction: props.isMobile ? 'column' : { xs: 'column', md: 'row' },
    }))``;

interface SoundContainerParams {
    isMobile: boolean;
}

export const SoundContainer = styled(Box)
    .withConfig({ displayName: 'SoundContainer' })
    .attrs<SoundContainerParams>((props) => ({
        ...props,
        position: 'absolute',
        top: props.isMobile ? 10 : 1.5,
        zIndex: 5,
    }))``;

interface TextContainerParams {
    isMobile: boolean;
}

export const TextContainer = styled(Box)
    .withConfig({
        displayName: 'TextContainer',
        shouldForwardProp: shouldIgnoreProp('isMobile'),
    })
    .attrs<TextContainerParams>((props) => ({
        ...props,
        width: props.isMobile ? '100%' : DESKTOP_TEXT_WIDTH,
        display: props.isMobile ? 'flex' : undefined,
        backgroundColor: props.isMobile
            ? 'var(--background-secondary)'
            : 'var(--background-primary)',
    }))`
    color: var(--color-primary);
`;

interface TextContentParams {
    isCut?: boolean;
    isMobile?: boolean;
}

export const TextContent = styled(Typography)
    .withConfig({ displayName: 'TextContent' })
    .attrs<TextContentParams>((props) => ({
        ...props,
        variant: 'body2',
        weight: 'regular',
        px: 2,
    }))`
    position: relative;
    height: calc(100% - 35px);
    width: 100%;
    overflow-y: auto;
    scrollbar-color: var(--color-secondary) transparent;
    scrollbar-width: thin;
    overflow-wrap: anywhere;

    ${(props) =>
        props.isCut &&
        css`
            overflow-y: hidden;
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
        `}
    ${(props) =>
        props.isMobile &&
        css`
            padding-top: 8px;
        `}

    ${(props) =>
        !props.isMobile &&
        css`
            &::after {
                z-index: 1;
                height: 8px;
                position: sticky;
                display: block;
                content: '';
                left: 0;
                width: 100%;
                pointer-events: none;
                bottom: -1px;
                background: linear-gradient(
                    to bottom,
                    rgba(var(--background-primary-rgb), 0) 0%,
                    var(--background-primary) 100%
                );
            }
        `}
`;

export const TextFooter = styled(Typography)
    .withConfig({ displayName: 'TextFooter' })
    .attrs((props) => ({
        ...props,
        variant: 'caption',
        weight: 'regular',
        height: 35,
        display: 'flex',
    }))`
    color: var(--color-secondary);
    align-items: center;
    flex-wrap: wrap;
`;

export const PostTextControlsContainer = styled(Flex)
    .withConfig({ displayName: 'PostTextControlsContainer' })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        spacing: 1,
        px: 1,
    }))``;

export const PostFooterContainer = styled(Flex)
    .withConfig({ displayName: 'PostFooterContainer' })
    .attrs((props) => ({
        ...props,
        as: 'footer',
        position: 'absolute',
        left: 2,
        bottom: 2,
        direction: 'row',
        alignItems: 'center',
        zIndex: 2,
    }))`
    justify-content: flex-end;
    width: calc(100% - 80px);
`;

export const PostControlsContainer = styled(Flex)
    .withConfig({ displayName: 'PostControlsContainer' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        zIndex: 2,
    }))``;

export const MediaContentClickBlocker = styled(Box)
    .withConfig({ displayName: 'MediaContentClickBlocker' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        top: 0,
        left: 0,
    }))``;

export const PostProfileText = styled(Typography)
    .withConfig({ displayName: 'PostProfileText' })
    .attrs((props) => ({
        ...props,
        variant: 'caption',
        textDecoration: 'none',
        overflow: 'hidden',
    }))`
    white-space: nowrap;
    text-overflow: ellipsis;
`;
